module.exports = __webpack_public_path__ + "static/media/Amir.2d0fd0d6.png";